// extracted by mini-css-extract-plugin
module.exports = {"layout":"callout_layout__r2A7O","graphic":"callout_graphic__TdJo2","content":"callout_content__cZjOy"};